import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'

import SearchPage from './pages/SearchPage';
import ConfirmationPage from './pages/ConfirmationPage';
import ReportPage from './pages/ReportPage';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<SearchPage />} />
        <Route path="/confirmation" element={<ConfirmationPage />} />
        <Route path="/report/:locationId" element={<ReportPage/>}/>
      </Routes>
    </Router>
  )
}

export default App
